export const EXECUTIVE_DETAILS = "EXECUTIVE_DETAILS";
export const EXECUTIVE_COMPANY_DETAILS = "EXECUTIVE_COMPANY_DETAILS";
export const EXECUTIVE_EMPLOYEE_LIST = "EXECUTIVE_EMPLOYEE_LIST";
export const EXECUTIVE_DEPARTMENT_LIST = "EXECUTIVE_DEPARTMENT_LIST";
export const EXECUTIVE_SUBMIT_EXECUTIVE_LEAD =
  "EXECUTIVE_SUBMIT_EXECUTIVE_LEAD";
export const EXECUTIVE_SIMILAR_COMPANYLIST = "EXECUTIVE_SIMILAR_COMPANYLIST";
export const EXECUTIVE_SUBMIT_ERROR_FORM = "EXECUTIVE_SUBMIT_ERROR_FORM";
export const EXECUTIVE_SINGLE_COMPANY_TAG = "EXECUTIVE_SINGLE_COMPANY_TAG";
export const EXECUTIVE_DOWNLOAD_COMPANY = "EXECUTIVE_DOWNLOAD_COMPANY";
export const EXECUTIVE_FETCH_COMPANY_TAG = "EXECUTIVE_FETCH_COMPANY_TAG";
export const EXECUTIVE_POST_RELAVANT_COMPANY_TAG =
  "EXECUTIVE_POST_RELAVANT_COMPANY_TAG";
export const EXECUTIVE_GET_RELAVANT_COMPANY_TAG =
  "EXECUTIVE_GET_RELAVANT_COMPANY_TAG";
export const EXECUTIVE_SELECTED_EXECUTIVE = "EXECUTIVE_SELECTED_EXECUTIVE";
export const EXECUTIVE_SELECTED_DEPARTMENT = "EXECUTIVE_SELECTED_DEPARTMENT";
export const EXECUTIVE_GET_EXECUTIVE_LEAD = "EXECUTIVE_GET_EXECUTIVE_LEAD";
export const GET_RELAVANT_EXECUTIVE_TAG = "GET_RELAVANT_EXECUTIVE_TAG";
export const POST_RELAVANT_EXECUTIVE_TAG = "POST_RELAVANT_EXECUTIVE_TAG";
export const EXECUTIVE_EMPLOYEE_VIEWABLE_STATUS =
  "EXECUTIVE_EMPLOYEE_VIEWABLE_STATUS";

export const EXECUTIVE_DETAILS_ERROR = "EXECUTIVE_DETAILS_ERROR";
export const EXECUTIVE_EMPTY_ERROR_OBJ = "EXECUTIVE_EMPTY_ERROR_OBJ_ERROR";
export const EXECUTIVE_COMPANY_DETAILS_ERROR =
  "EXECUTIVE_COMPANY_DETAILS_ERROR";
export const EXECUTIVE_EMPLOYEE_LIST_ERROR = "EXECUTIVE_EMPLOYEE_LIST_ERROR";
export const EXECUTIVE_DEPARTMENT_LIST_ERROR =
  "EXECUTIVE_DEPARTMENT_LIST_ERROR";
export const EXECUTIVE_SUBMIT_EXECUTIVE_LEAD_ERROR =
  "EXECUTIVE_SUBMIT_EXECUTIVE_LEAD_ERROR";
export const EXECUTIVE_SIMILAR_COMPANYLIST_ERROR = "SIMILAR_COMPANYLIST_ERROR";
export const EXECUTIVE_SUBMIT_ERROR_FORM_ERROR =
  "EXECUTIVE_SUBMIT_ERROR_FORM_ERROR";
export const EXECUTIVE_SINGLE_COMPANY_TAG_ERROR =
  "EXECUTIVE_SINGLE_COMPANY_TAG_ERROR";
export const EXECUTIVE_DOWNLOAD_COMPANY_ERROR =
  "EXECUTIVE_DOWNLOAD_COMPANY_ERROR";
export const EXECUTIVE_FETCH_COMPANY_TAG_ERROR =
  "EXECUTIVE_FETCH_COMPANY_TAG_ERROR";
export const EXECUTIVE_POST_RELAVANT_COMPANY_TAG_ERROR =
  "EXECUTIVE_POST_RELAVANT_COMPANY_TAG_ERROR";
export const EXECUTIVE_GET_RELAVANT_COMPANY_TAG_ERROR =
  "EXECUTIVE_GET_RELAVANT_COMPANY_TAG_ERROR";
export const EXECUTIVE_DOWNLOAD_EXECUTIVE_ERROR =
  "EXECUTIVE_DOWNLOAD_EXECUTIVE_ERROR";
export const EXECUTIVE_GET_EXECUTIVE_LEAD_ERROR =
  "EXECUTIVE_GET_EXECUTIVE_LEAD_ERROR";
export const GET_RELAVANT_EXECUTIVE_TAG_ERROR =
  "GET_RELAVANT_EXECUTIVE_TAG_ERROR";
export const POST_RELAVANT_EXECUTIVE_TAG_ERROR =
  "POST_RELAVANT_EXECUTIVE_TAG_ERROR";
export const EXECUTIVE_EMPLOYEE_VIEWABLE_STATUS_ERROR =
  "EXECUTIVE_EMPLOYEE_VIEWABLE_STATUS_ERROR";
